import i18n from '../app/i18n';
import { ModalType, SnackBarType } from '../app/types';
import { closeModal, openModal } from './modalSlice';
import { enqueueSnackbar } from './notifierSlice';

const errorHandle =
  (error, isMobile, callback = () => {}) =>
  async dispatch => {
    const errorMsg =
      error?.response?.data?.error ||
      error?.response?.data?.code ||
      error?.message ||
      error;

    if (isMobile) {
      switch (errorMsg) {
        case 'SurveyCakeInvalidParameter':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`SurveyCakeInvalidParameterErrorTitle`),
                content: i18n.t(`SurveyCakeInvalidParameterErrorContent`),
              },
            }),
          );
          break;
        case 'SurveyCakeOnceByCustomerError':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`SurveyCakeOnceByCustomerErrorTitle`),
                content: i18n.t(`SurveyCakeOnceByCustomerErrorContent`),
              },
            }),
          );
          break;
        case 'SurveyCakePapperNotFound':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`SurveyCakePapperNotFoundTitle`),
                content: i18n.t(`SurveyCakePapperNotFoundContent`),
              },
            }),
          );
          break;
        case 'EcCustomerNotFoundError':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`ecBinding:EcCustomerNotFoundError`),
                onClick: () => {
                  dispatch(closeModal());
                  callback();
                },
                submitText: i18n.t(`ecBinding:EcCustomerNotFoundError-btn`),
              },
            }),
          );
          break;
        // 綁定失敗查無用戶
        case 'EcProviderCustomerNotFoundError':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`ecBinding:EcProviderCustomerNotFoundError`),
                onClick: () => {
                  dispatch(closeModal());
                  callback();
                },
                submitText: i18n.t(
                  `ecBinding:EcProviderCustomerNotFoundError-btn`,
                ),
              },
            }),
          );
          break;
        case 'EcCouponInsufficientError':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`ecBinding:EcCouponInsufficientError`),
                onClick: () => {
                  dispatch(closeModal());
                  callback();
                },
                submitText: i18n.t(`ecBinding:EcCouponInsufficientError-btn`),
              },
            }),
          );
          break;
        case 'EcInvalidAuthCodeError':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`ecBinding:EcInvalidAuthCodeError`),
                onClick: () => {
                  dispatch(closeModal());
                },
                submitText: i18n.t(`ecBinding:EcInvalidAuthCodeError-btn`),
              },
            }),
          );
          break;
        case 'server-error':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`error-server-error-title`),
                content: i18n.t(`error-server-error`),
                onClick: () => {
                  dispatch(closeModal());
                },
                submitText: i18n.t(`error-modal-btn`),
              },
            }),
          );
          break;
        case 'token-expired':
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`error-modal-default-title`),
                content: i18n.t(`error-jwt-expired`),
                onClick: () => {
                  dispatch(closeModal());
                },
                submitText: i18n.t(`error-modal-btn`),
              },
            }),
          );
          break;
        default:
          dispatch(
            openModal({
              modalType: ModalType.AWARD_MODAL,
              modalProps: {
                title: i18n.t(`error-modal-default-title`),
                content: errorMsg,
                onClick: () => {
                  dispatch(closeModal());
                },
                submitText: i18n.t(`error-modal-btn`),
              },
            }),
          );
          break;
      }
    } else {
      switch (errorMsg) {
        case 'ECConnectFailed':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`ecBinding:ECConnectFailed`),
            }),
          );
          break;
        case 'error/hourly_limit':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`aiBot:error/hourly_limit`),
            }),
          );
          break;
        case 'error/fail_to_fetch_sitemap':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`aiBot:error/fail_to_fetch_sitemap`),
            }),
          );
          break;
        case 'error/file_type_not_supported':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`aiBot:error/file_type_not_supported`),
            }),
          );
          break;
        case 'data-error':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`data-error`),
            }),
          );
          break;
        case 'EcTokenAlreadyUsedError':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`ecBinding:EcTokenAlreadyUsedError`),
            }),
          );
          break;
        case 'server-error':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`error-server-error`),
            }),
          );
          break;
        case 'error from token':
        case 'error from credential':
        case 'error from token limit':
        case 'invalid-session-token':
        case 'token-expired':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`error-jwt-expired`),
            }),
          );
          break;
        case 'error/usage_limit':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.WARNING,
              message: i18n.t(`aiBot:${errorMsg}`),
            }),
          );
          break;
        case 'error/quota_exceeded':
        case 'error/words_limit_exceeded':
        case 'error/empty_content':
        case 'error/invalid_config':
        case 'error/dataset_not_ready':
        case 'error/already_started':
        case 'error/embedding_will_not_start':
        case 'error/usage_limit_exceeded':
        case 'error/file_size_exceeded':
        case 'error/file_format_error':
        case 'error/invalid_url':
        case 'error/aiBot_already_published':
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: i18n.t(`aiBot:${errorMsg}`),
            }),
          );
          break;
        default:
          // eslint-disable-next-line no-console
          console.error(errorMsg);
          dispatch(
            enqueueSnackbar({
              variant: SnackBarType.ERROR,
              message: errorMsg,
            }),
          );
          break;
      }
    }
  };

export default errorHandle;
